import EntryForm from "@/components/finance/EntryForm";

export const FinanceMixin = {
    async mounted() {
        this.resetFilters();
        await this.$store.dispatch("finance/fetchEntries");
        if(this.$store.getters["sites/allSites"].length === 0) {
            await this.$store.dispatch("sites/fetchSites");
        }
        this.entriesLoaded = true;
        let type = this.$route.query.type;
        if(type) {
            this.filter_type = type;
            this.displayContractWithTypeChange();
        }
        let statut = this.$route.query.statut;
        if(statut) {
            this.filter_depense = statut;
            this.displayContract = true;
        }
    },
    data() {
        return {
            deleteDialog: false,
            entriesLoaded: false,
            entry_to_delete: null,
        }
    },
    computed: {
        types_depense() {
            return [
                {"name": ""},
                {"name": "Budget"},
                {"name": "Dépense ponctuelle"},
                {"name": "Dépense sous contrat"},
                {"name": "Dépense sous contrat supplémentaire"},
                {"name": "Casse"},
            ];
        },
        active_years() {
            return this.$store.getters["finance/stats/active_years"];
        },
        statut_depense() {
            return [
                {value: "", name: "Toutes les dépenses"},
                {value: "previsionnel", name: "Prévisionnel"},
                {value: "realise", name: "Réalisé"}
            ]
        },
        data_entries() {
            return this.$store.getters['finance/filter/getFilteredEntries'];
        },
        entries() {
            return this.$store.getters["finance/allEntries"];
        },
        displayContract: {
            get() {
                return this.$store.getters['finance/filter/getDisplayContract'];
            },
            set(value) {
                this.$store.commit("finance/filter/setDisplayContract", value);
            }
        },
        filter_type: {
            get() {
                return this.$store.getters['finance/filter/getFilterType'];
            },
            set(value) {
                this.$store.commit("finance/filter/setFilterType", value);
            }
        },
        filter_site_tree: {
            get() {
                return this.$store.getters['finance/filter/getFilterSiteTree'];
            },
            set(value) {
                this.$store.commit("finance/filter/setFilterSiteTree", value);
            }
        },
        filter_depense: {
            get() {
                return this.$store.getters['finance/filter/getFilterDepense'];
            },
            set(value) {
                this.$store.commit("finance/filter/setFilterDepense", value);
            }
        },
        filter_year: {
            get() {
                return this.$store.getters['finance/filter/getFilterYear'];
            },
            set(value) {
                this.$store.commit("finance/filter/setFilterYear", value);
            }
        }
    },
    methods: {
        editEntry(entry) {
            let found_entry = this.entries.find(item => entry.id === item.id);
            this.openDrawerDialog(EntryForm, {key: entry.id, entryToUpdate: found_entry, operation: "update"});
        },
        askDeleteEntry(entry) {
            this.entry_to_delete = entry;
            this.deleteDialog = true;
        },
        async deleteEntry() {
            await this.$store.dispatch("finance/deleteEntry", this.entry_to_delete);
            await this.$store.dispatch("messages/announceSuccess", "Entrée financière supprimée.");
            this.entry_to_delete = null;
            this.deleteDialog = false;
        },
        openNewEntryDrawer() {
            this.openDrawerDialog(EntryForm, {key: 0, entryToUpdate: null, operation: "create"});
        },
        displayContractWithTypeChange() {
            if (this.filter_type === 'Dépense sous contrat') {
                this.displayContract = true;
            }
        },
        resetFilters() {
            this.filter_depense = "";
            this.displayContract = false;
            this.filter_type = "";
            this.filter_year = null;
            this.filter_site_tree = [];
        }
    }
}